import {
  ModalHeader,
  ModalContent,
  ModalActions,
  Button,
  Text,
} from '@lightspeed/design-system-react'
import React, { FC } from 'react'
import { useT } from '@transifex/react'
import { SwiperErrorMessage } from '../../hooks/use-swiper-payment-reducer/types'
interface Props {
  errorMessage: SwiperErrorMessage
  onClose: () => void
}
export const Error: FC<Props> = ({ errorMessage, onClose }) => {
  const t = useT()
  return (
    <>
      <ModalHeader>{errorMessage.header}</ModalHeader>
      <ModalContent>
        <Text tag="p">{errorMessage.content}</Text>
        {errorMessage.econduitError && (
          <Text tag="p">
            {t('The processor error is: {econduitError}', {
              econduitError: errorMessage.econduitError,
              _context:
                'The payment prompt description indicates that the processor error is with the econduit error',
            })}
          </Text>
        )}
      </ModalContent>
      <ModalActions>
        <Button onClick={() => onClose()}>
          {t('Got it, thanks!', {
            _context: 'Button label for acknowledging the error message',
          })}
        </Button>
      </ModalActions>
    </>
  )
}
